export const DEFAULT_INTL = 'en-US'

export const COUNTRIES_QUERY_KEY = 'countries'
export const LANGUAGES_QUERY_KEY = 'languages'

// MSAL id token persisted by the shell (admin-dashboard-shell-mfe); shared across MFEs via same-origin localStorage.
export const MSAL_ACCESS_TOKEN_KEY = 'msalAccessToken'
export const TEXT_TAG_ACTIVATION_CHAR = '$'
